import { Button, EmptyState, InlineAlert, Page, PageContent } from '@planuze/ui';
import { Link } from '@tanstack/react-router';
import { CompassIcon } from 'lucide-react';
import type { JSX } from 'react';
import { useCommonContent } from '../content/sections/common.js';

/* Fallbacks globais do router (ADR-0699/§6/§10). Antes o TanStack caía no fallback cru; agora
   erro de rota/loader e URL desconhecida têm superfície do produto com recuperação. */

export function RouteErrorFallback({ reset }: { readonly reset: () => void }): JSX.Element {
  const copy = useCommonContent().routeFallbacks;
  return (
    <Page>
      <PageContent className="grid place-items-center">
        <div className="w-full max-w-md space-y-3 text-center">
          <InlineAlert variant="destructive">{copy.errorMessage}</InlineAlert>
          <Button onClick={reset}>{copy.retry}</Button>
        </div>
      </PageContent>
    </Page>
  );
}

export function RouteNotFound(): JSX.Element {
  const copy = useCommonContent().routeFallbacks;
  return (
    <Page>
      <PageContent className="grid place-items-center">
        <EmptyState
          icon={<CompassIcon className="size-7" aria-hidden="true" />}
          title={copy.notFoundTitle}
          description={copy.notFoundDescription}
          primaryAction={
            <Button asChild>
              <Link to="/dashboard">{copy.backToDashboard}</Link>
            </Button>
          }
        />
      </PageContent>
    </Page>
  );
}
